import Vue from 'vue'
import { startCase } from 'lodash'

Vue.filter('capitalize', (value) => {
  if (typeof value !== 'string') {
    return ''
  }
  return startCase(value.toLowerCase())
})
